interface IInputOutlineProps {
  label?: string;
  name: string;
  labelColor?: string;
  labelClassName?: string;
  LabelComponent?: React.ComponentType<any>;
  labelComponentProps?: Record<string, any>;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type InputOutlineProps = IInputOutlineProps;

const InputOutline: React.FC<any> = ({
  label,
  name,
  backgroundWidth,
  selectedItem,
  labelColor,
  labelClassName,
  LabelComponent,
  labelComponentProps,
}) => {
  const isWww = label === "www";
  return (
    <div className="formControl__outline" style={{ borderRadius: "10px" }}>
      <div
        className="formControl__outline--item1"
        style={{ paddingLeft: "9px" }}
      ></div>
      {label && (
        <div className="formControl__outline--item2" style={{ flex: "1 0 0%" }}>
          {LabelComponent ? (
            <LabelComponent
              data-testid=""
              htmlFor={name}
              className={labelClassName}
              {...labelComponentProps}
            >
              <div
                style={{
                  textTransform: isWww ? "lowercase" : undefined,
                  display: isWww ? "inline-block" : undefined,
                }}
              >
                {label}
              </div>
            </LabelComponent>
          ) : labelClassName ? (
            <label data-testid="" htmlFor={name} className={labelClassName}>
              <div
                style={{
                  textTransform: isWww ? "lowercase" : undefined,
                  display: isWww ? "inline-block" : undefined,
                }}
              >
                {label}
              </div>
            </label>
          ) : (
            <label
              data-testid=""
              htmlFor={name}
              style={{
                position: "absolute",
                top: "7px",
                left: "9px",
                fontSize: "11px",
                letterSpacing: 0,
                fontWeight: 400,
                color: labelColor || "#9CB0C4",
              }}
            >
              <div
                style={{
                  textTransform: isWww ? "lowercase" : undefined,
                  display: isWww ? "inline-block" : undefined,
                }}
              >
                {label}
              </div>
            </label>
          )}
        </div>
      )}{" "}
      <div
        className="formControl__outline--item3"
        style={{
          flex: "unset",
        }}
      ></div>
    </div>
  );
};

export default InputOutline;
